module.exports = __webpack_public_path__ + "static/media/johnnychild.c8a6aa27.webp";